import {
  COLLECTIBLE_TYPES,
  COLLECTIBLE_COLORS,
  PLAYFIELD,
} from '../core/Constants';

/**
 * Falling Power-up Capsule (Pill)
 */
export class Collectible {
  constructor(x, y, type) {
    this.x = x;
    this.y = y;
    this.width = 28;
    this.height = 14;
    this.type = type;
    this.colorIndex = COLLECTIBLE_COLORS[type] || 1;
    this.speed = 2.4;
    this.rotation = 0.0;
    this.rotationSpeed = 4.5;
    this.destroyed = false;
  }

  update(dt) {
    this.y += this.speed * dt * 60;
    this.rotation += this.rotationSpeed * dt;
    if (this.y > PLAYFIELD.bottom + 20) {
      this.destroyed = true;
    }
  }

  getBounds() {
    return {
      left: this.x - this.width / 2,
      right: this.x + this.width / 2,
      top: this.y - this.height / 2,
      bottom: this.y + this.height / 2,
    };
  }

  checkCollision(paddle) {
    const pBounds = paddle.getBounds();
    const cBounds = this.getBounds();

    return (
      cBounds.right >= pBounds.left &&
      cBounds.left <= pBounds.right &&
      cBounds.bottom >= pBounds.top &&
      cBounds.top <= pBounds.bottom
    );
  }

  // Returns numeric code for fragment shader
  getTypeIndex() {
    const mapping = {
      [COLLECTIBLE_TYPES.SLOW]: 1,
      [COLLECTIBLE_TYPES.CATCH]: 2,
      [COLLECTIBLE_TYPES.LASER]: 3,
      [COLLECTIBLE_TYPES.EXPAND]: 4,
      [COLLECTIBLE_TYPES.DISRUPT]: 5,
      [COLLECTIBLE_TYPES.BREAK]: 6,
      [COLLECTIBLE_TYPES.PLAYER]: 7,
    };
    return mapping[this.type] || 1;
  }
}
